import { useHasPermission, hasPermission } from '~/modules/common/permissions';
import { isMobileApp } from '~/util';

export const isCostManagerEnabled = ({ permissionsMap }) => {
  if (isMobileApp()) return false;
  const permissionFunc = hasPermission(permissionsMap);

  return (
    permissionFunc({
      actionUri: 'urn:replicon:timesheet-action:view-timesheet',
      dataAccessLevelUri:
        'urn:replicon:timesheet-data-access-level:cost-manager-data-access-scope'
    }) ||
    permissionFunc({
      actionUri: 'urn:replicon:expense-action:view-expense-sheet',
      dataAccessLevelUri:
        'urn:replicon:expense-data-access-level:cost-manager-data-access-scope'
    }) ||
    permissionFunc({
      actionUri:
        'urn:replicon:time-data-workbench-action:view-time-data-workbench'
    })
  );
};

export const useCostManagerPermissions = () => {
  const mobileAppValue = isMobileApp();
  const isSupportedDevice =
    mobileAppValue !== true && mobileAppValue !== 'true';

  const hasAccessToTimesheets =
    useHasPermission({
      actionUri: 'urn:replicon:timesheet-action:view-timesheet',
      dataAccessLevelUri:
        'urn:replicon:timesheet-data-access-level:cost-manager-data-access-scope'
    }) && isSupportedDevice;
  const hasAccessToExpenses =
    useHasPermission({
      actionUri: 'urn:replicon:expense-action:view-expense-sheet',
      dataAccessLevelUri:
        'urn:replicon:expense-data-access-level:cost-manager-data-access-scope'
    }) && isSupportedDevice;
  const hasAccessToTimeWorkbench =
    useHasPermission({
      actionUri:
        'urn:replicon:time-data-workbench-action:view-time-data-workbench'
    }) && isSupportedDevice;
  const isTimeAdmin = hasAccessToTimesheets || hasAccessToTimeWorkbench;
  const title =
    isTimeAdmin && hasAccessToExpenses
      ? 'timeAndExpenseAdmin.title'
      : isTimeAdmin
      ? 'timeAndExpenseAdmin.timeAdmin'
      : 'timeAndExpenseAdmin.expenseAdmin';

  return {
    isCostManager:
      hasAccessToTimesheets || hasAccessToExpenses || hasAccessToTimeWorkbench,
    hasAccessToTimesheets,
    hasAccessToExpenses,
    hasAccessToTimeWorkbench,
    titleId: title
  };
};
